import { PersonalizationPreferences } from './PersonalizationTypes'
const STORAGE_KEY = 'uncover_personalization_preferences'
const SEEN_KEY = 'uncover_has_seen_questionnaire'
export const getDefaultPreferences = (): PersonalizationPreferences => ({
  relationshipStyle: '',
  desiredDynamics: [],
  kinks: [],
  softKinks: [],
  hardKinks: [],
  kinkComfortLevel: 5,
  personalityType: '',
  desiredPartnerType: '',
  conversationStyle: '',
  topicPreferences: [],
  privacyConcerns: [],
  comfortZones: [],
  memoryPreference: 'short-term',
  favoriteScenarios: [],
  upsellTone: 'subtle',
  nsfwBoundary: 'medium',
  emotionalTriggers: [],
  humorStyle: [],
  interactionPacing: 5,
  surpriseContentOk: true,
  multimediaPreference: ['text'],
  loveLanguage: '',
  sexualConfidence: 5,
  toyInterest: 5,
  tabooRoleplayWillingness: 3,
  interactionIntensity: 5,
  diaryFeatureInterest: true,
})
export const savePreferences = (
  preferences: PersonalizationPreferences,
): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences))
  } catch (error) {
    console.error('Failed to save personalization preferences:', error)
  }
}
export const getPreferences = (): PersonalizationPreferences => {
  try {
    const storedPrefs = localStorage.getItem(STORAGE_KEY)
    return storedPrefs ? JSON.parse(storedPrefs) : getDefaultPreferences()
  } catch (error) {
    console.error('Failed to retrieve personalization preferences:', error)
    return getDefaultPreferences()
  }
}
export const markQuestionnaireAsSeen = (): void => {
  try {
    localStorage.setItem(SEEN_KEY, 'true')
  } catch (error) {
    console.error('Failed to mark questionnaire as seen:', error)
  }
}
export const hasSeenQuestionnaire = (): boolean => {
  try {
    return localStorage.getItem(SEEN_KEY) === 'true'
  } catch (error) {
    console.error('Failed to check if questionnaire has been seen:', error)
    return false
  }
}
export const resetQuestionnaireStatus = (): void => {
  try {
    localStorage.removeItem(SEEN_KEY)
  } catch (error) {
    console.error('Failed to reset questionnaire status:', error)
  }
}
